import { createAuthServiceGa } from './GAAuthService';

const authPlugin = {
  install(Vue, options) {
    let auth = createAuthServiceGa(options);

    Vue.prototype.$GAUserAuth = auth;
  },
};

export { authPlugin as default };
